<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData"></Filter>
    <div class="chart-container">
      <div class="canvas" id="lineChart"></div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, onUnmounted } from 'vue'
// import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import Filter from '@/components/table/filter'
import { request } from '@/utils/request'
import { common } from '@/common/mixin'
import { getUrlParam } from '@/common/utils'
// import * as echarts from "echarts";
import dayjs from 'dayjs'
import * as echarts from 'echarts/core'
import {
  DatasetComponent,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  ToolboxComponent,
  DataZoomComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import { useI18n } from 'vue-i18n'

export default {
  components: {
    Filter
  },
  mixins: [common],
  setup () {
    const { t } = useI18n()
    echarts.use([
      DatasetComponent,
      TitleComponent,
      TooltipComponent,
      DataZoomComponent,
      LegendComponent,
      ToolboxComponent,
      GridComponent,
      CanvasRenderer,
      LineChart
    ])
    const robotId = getUrlParam(window.location.href, 'robotSn')
    let lineChart = null // echarts 实例
    let healthScoreTrendData = []
    const state = reactive({
      query: {
        robotSN: robotId, // Zu3100161
        startTime:  dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
        endTime: dayjs().format('YYYY-MM-DD') + ' 23:59:59',
        field: 'Peak_Torque',
      },
      params: [
        {
          type: 'Input',
          key: 'robotSN',
          value: robotId,
          label: t('activity.packetjoin.robotCode')
        },
        {
          type: "Select",
          key: "field",
          value: 'Peak_Torque',
          label: t('collect.healthscoretrend.parameters'),
          options: {
            data: [
              {label: t('collect.healthscoretrend.peakTorque'),value: "Peak_Torque"},
              {label: t('collect.healthscoretrend.averageTorque'),value: "Average_Torque"},
              {label: t('collect.healthscoretrend.dualEncoderDifference'),value: "Max_Dual_Encoder_Diff"},
              {label: t('collect.healthscoretrend.jointHealthScore'),value: "Joint_Health_Score"},
            ],
            label: "label",
            value: "value"
          }
        },
        {
          type: 'Date',
          key: 'dateRange',
          label: t('collect.healthscorelist.updateDate'),
          value: [
            dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
            dayjs().format('YYYY-MM-DD') + ' 23:59:59'
          ],
          options: {
            type: 'datetimerange',
            format: 'YYYY-MM-DD HH:mm:ss',
            'value-format': 'YYYY-MM-DD HH:mm:ss',
            'range-separator': t('activity.detail.to'),
            'start-placeholder': t('activity.list.startDate'),
            'end-placeholder': t('activity.list.endDate'),
            'default-time': [
              new Date(1989, 1, 1, 0, 0, 0),
              new Date(2000, 1, 1, 23, 59, 59)
            ]
          }
        },
      ],
      fieldData: {"Peak_Torque": t('collect.healthscoretrend.peakTorqueNm'),"Average_Torque": t('collect.healthscoretrend.averageTorqueNm'), "Max_Dual_Encoder_Diff": t('collect.healthscoretrend.dualEncoderDifferenceDeg'),"Joint_Health_Score": `${t('collect.healthscoretrend.jointHealthScore')}（ % ）`}
    })
    // 生成一周以内的数据（7天）
    // 原始数据模板
    const originalData = {
      "cabinetSn": "",
      "robotSn": "",
      "customerName": "",
      "score": 0,
      "createTime": "",
      "report": "",
      "comment": "",
      "id": "",
      "taskId": ""
    };
    const generateWeeklyData = () => {
      const weeklyData = [];
      for (let i = 0; i < 7; i++) {
        const date = dayjs().subtract(i, 'day');
        const newData = {
          ...originalData,
          createTime: date.format('YYYY-MM-DD HH:mm:ss'),
          // 可以添加一些变化，比如分数每天稍微变化
          score: 0,
          // 每天生成不同的ID
          id: '',
          // 每天生成不同的taskId（日期部分变化）
          taskId: ''
        };
        weeklyData.push(newData);
      }
      healthScoreTrendData = weeklyData
      return weeklyData;
    }
    const getHealthScoreTrendData = async () => {
      try {
        const res = await request('getHealthScoreTrend', {
          ...state.query
        })
        healthScoreTrendData = res || []
        healthScoreTrendData = healthScoreTrendData.map(item=>{
          item.score = item.score * 100
          item.report = JSON.parse(item.report)
          console.log('cwwww', state.query.field)
          item.joint1 = item.report[0][state.query.field]?.toFixed(3) || 0
          item.joint2 = item.report[1][state.query.field]?.toFixed(3) || 0
          item.joint3 = item.report[2][state.query.field]?.toFixed(3) || 0
          item.joint4 = item.report[3][state.query.field]?.toFixed(3) || 0
          item.joint5 = item.report[4][state.query.field]?.toFixed(3) || 0
          item.joint6 = item.report[5][state.query.field]?.toFixed(3) || 0
          if(state.query.field == 'Joint_Health_Score'){
            item.joint1 = ((item.report[0][state.query.field] || 0) * 100).toFixed(3)
            item.joint2 = ((item.report[1][state.query.field] || 0) * 100).toFixed(3)
            item.joint3 = ((item.report[2][state.query.field] || 0) * 100).toFixed(3)
            item.joint4 = ((item.report[3][state.query.field] || 0) * 100).toFixed(3)
            item.joint5 = ((item.report[4][state.query.field] || 0) * 100).toFixed(3)
            item.joint6 = ((item.report[5][state.query.field] || 0) * 100).toFixed(3)
          }
          return item
        })
        if (healthScoreTrendData.length <= 0) return
        lineChart.resize()
        lineChart.setOption({
          title: {
            text: t('pages.healthTrend')
          },
          xAxis: {
            max: healthScoreTrendData[0].createTime || dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
            min: healthScoreTrendData[healthScoreTrendData.length -1].createTime || dayjs().format('YYYY-MM-DD') + ' 23:59:59'
          },
          yAxis: [
            {
              name: state.fieldData[state.query.field],
              type: 'value',
              splitLine: {
                show: false
              },
              axisLine: {
                show: false
              },
            },
            {
              name: t('collect.healthscoretrend.healthScorePercent'),
              // nameLocation: 'start',
              alignTicks: true,
              type: 'value',
              // inverse: true,
              splitLine: {
                show: false
              },
              axisLine: {
                show: false
              },
            },
          ],
          dataset: {
            source: healthScoreTrendData
          }
        })
      } catch (error) {
        console.error(error)
      }
    }
    const searchData = async data => {
      state.query = data
      if (!state.query.robotSN) {
        ElMessage({
          showClose: true,
          type: 'warning',
          message: t('collect.healthscoretrend.robotCodeEmpty')
        })
        return
      }
      if (data.dateRange && data.dateRange.length > 0) {
        state.query.startTime = data.dateRange[0]
        state.query.endTime = data.dateRange[1]
      } else {
        state.query.startTime = ''
        state.query.endTime = ''
      }
      getHealthScoreTrendData()
    }
    onMounted(() => {
      if(robotId){
        getHealthScoreTrendData()
      }else{
        generateWeeklyData()
      }
      lineChart = echarts.init(document.getElementById('lineChart'))
      const lineOption = {
        title: {
          text: t('pages.healthTrend')
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [t('collect.healthscorelist.healthScore'),t('collect.healthscoretrend.joint1'), t('collect.healthscoretrend.joint2'), t('collect.healthscoretrend.joint3'), t('collect.healthscoretrend.joint4'), t('collect.healthscoretrend.joint5'), t('collect.healthscoretrend.joint6')]
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        dataset: {
          dimensions: ['createTime', 'score','joint1', 'joint2', 'joint3', 'joint4', 'joint5', 'joint6'],
          source: healthScoreTrendData
        },
        xAxis: [{
          type: 'time',
          // min: "2022-01-01 00:00:00",
          splitLine: {
            show: false
          },
          boundaryGap: false,
          axisLine: { onZero: false }
        }],
        yAxis: [
          {
            name: state.fieldData[state.query.field],
            type: 'value',
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            },
            nameTextStyle: {
              padding: [0, 0, 0, 40] // 左上右下四个方向的padding
            },
            // offset: 0 // 整个yAxis的偏移量
          },
          {
            name: t('collect.healthscoretrend.healthScorePercent'),
            // nameLocation: 'start',
            alignTicks: true,
            type: 'value',
            // inverse: true,
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            },
          },
        ],
        dataZoom: [
          // {
          //   type: 'inside',
          //   start: 0,
          //   end: 100
          // },
          {
            start: 0,
            end: 100
          }
        ],
        series: [
          { yAxisIndex: 1, name: t('collect.healthscorelist.healthScore'), type: 'line', encode: { x: 'createTime', y: 'score' }, showSymbol: false, sampling: 'average'},
          { name: t('collect.healthscoretrend.joint1'), type: "line", encode: { x: 'createTime', y: 'joint1' }, showSymbol: false, sampling: 'average'},
          { name: t('collect.healthscoretrend.joint2'), type: "line", encode: { x: 'createTime', y: 'joint2' }, showSymbol: false, sampling: 'average'},
          { name: t('collect.healthscoretrend.joint3'), type: "line", encode: { x: 'createTime', y: 'joint3' }, showSymbol: false, sampling: 'average'},
          { name: t('collect.healthscoretrend.joint4'), type: "line", encode: { x: 'createTime', y: 'joint4' }, showSymbol: false, sampling: 'average'},
          { name: t('collect.healthscoretrend.joint5'), type: "line", encode: { x: 'createTime', y: 'joint5' }, showSymbol: false, sampling: 'average'},
          { name: t('collect.healthscoretrend.joint6'), type: "line", encode: { x: 'createTime', y: 'joint6' }, showSymbol: false, sampling: 'average'}
        ],
        animation: false
      }
      lineChart.setOption(lineOption)
    })
    onUnmounted(() => {
      lineChart && lineChart.dispose()
    })
    return {
      ...toRefs(state),
      searchData,
      getHealthScoreTrendData,
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.chart-container {
  position: relative;
  margin-top: 10px;
  padding: 10px 10px;
  flex: 1;
  // overflow: hidden;
  border-color: #fff;
  border-radius: 5px;
  background-color: #fff;
  .canvas {
    width: 100%;
    height: 100%;
  }
}
</style>
